import InsightsFileSettings from '../../components/MySettings/insightsFile'
import { connect } from 'react-redux'

import { setReportWebSiteId } from '../../actions/Insights'

import { setSettingsWebsiteId, saveInsightsFileSetup, clearInsightsFileSettingsSaveError } from '../../actions/settings'
import {getClientSites, getClientTags} from '../../actions/Clients'
import {getClientInfo} from '../../actions/App'

const mapStateToProps = (state) => {
	const { selected_client, client_info, clients } = state.app
	const { /*websiteId,*/ insights_file_save_success,insights_file_save_error_message, 
		insights_file_on_saving } = state.settings;
    const { websiteId } = state.insights;
	const { client_sites, client_tags, client_tags_on_loading } = state.clients;

	return {
		websiteId,
		selected_client,
		client_info,
		client_sites,
		client_tags,
		clients,
		insights_file_save_success,
		insights_file_save_error_message,
		insights_file_on_saving,
		client_tags_on_loading
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getClientSites: (cid) => {
      dispatch(getClientSites(cid))
		},
		getClientTags: (clientId) => {
      dispatch(getClientTags(clientId))
    },
		setWebsiteId: (id) => {
      dispatch(setReportWebSiteId(id))
      dispatch(setSettingsWebsiteId(id))
		},
		saveInsightsFileSetup: (clientId, tagId, obj) =>{
			dispatch(saveInsightsFileSetup(clientId, tagId, obj))
		},
		getClientInfo: (id) => {
      dispatch(getClientInfo(id))
    },
		clearInsightsFileSettingsSaveError: () => {
			dispatch(clearInsightsFileSettingsSaveError())
		}
	}
}

const InsightsFileSettingsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(InsightsFileSettings)

export default InsightsFileSettingsContainer;


// WEBPACK FOOTER //
// ./src/containers/Settings/InsightsFile.js